import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import BlogTeaser from '../elements/blog_teaser'
import {
    Alignment,
    Button,
    Classes,
    H5,
    Navbar,
    NavbarDivider,
    NavbarGroup,
    NavbarHeading,
    Switch,
} from "@blueprintjs/core";


class Blog extends Component {

    blog_data = [
        {"name":"AI just as good at diagnosing illness as humans",
        "teaser":"A new article examines the existing evidence in an attempt to determine whether AI can diagnose illnesses as effectively as healthcare ...",
        "source": "", 
        "link":"",
        },
        {"name":"Israel Prepares to Unleash AI on Health Care",
        "teaser":"And the greater goals, officials say, based largely on the promise of AI technology, are to make health care less expensive, more effective and ...",
        "source": "", 
        "link":"",
        },
        {"name":"Amazon Takes Another Big Step Toward Getting Into Healthcare",
        "teaser":"Promising to offer the best of both in-person and virtual healthcare, Amazon ... Similarly, voice-activated AI Alexa forms a basis for Amazon to ...",
        "source": "", 
        "link":"",
        },
        {"name":"Artificial intelligence in medicine raises legal and ethical concerns",
        "teaser":"In a forthcoming article, I argue that policymakers should establish a number of ... If AI generates predictions about your health, I believe that ...",
        "source": "", 
        "link":"",
        },
        {"name":"AI-enhanced ECGs may soon assess overall health",
        "teaser":"Scientists have trained an artificial intelligence tool to predict sex and estimate age from electrocardiogram readouts. They suggest that, with ...",
        "source": "", 
        "link":"",
        },
        {"name":"AI: Giving healthcare professionals 'The Gift of Time'",
        "teaser":"AI will transform the lives of both patients and healthcare ... ourselves at a critical point in the evolution of artificial intelligence (AI) in healthcare.",
        "source": "", 
        "link":"",
        },
        {"name":"Data sharing is key to innovation in health care",
        "teaser":"To improve people’s quality of life and prevent disease, health systems worldwide need to embrace digital platforms.",
        "source": "technologyreview", 
        "link":"https://www.technologyreview.com/s/614442/data-sharing-is-key-to-innovation-in-health-care/",
        },
        {"name":"How Much Is AI Really Moving the Needle on Health?",
        "teaser":"When it comes to health and wellness, most people have a similar goal: we want to live a healthier, longer, and happier life.",
        "source": "singularityhub", 
        "link":"https://singularityhub.com/2019/08/26/how-much-is-ai-really-moving-the-needle-on-health/?utm_medium=email&utm_content=how-much-is-ai-really-moving-the-needle-on-health&utm_source=newsletter&utm_campaign=fy18-hub-daily-rss-newsletter&mkt_tok=eyJpIjoiTjJWaE1XRXdZelExWW1OaSIsInQiOiJpOW43MDNaWlhOYlh0YmdRSVJOOGJ2Q002MFwvblhhV3pcL203aUhZRWUrRzNJZGVUQk4xb1BEOEdrXC80YzVJNVp1RWRBVlNzdEx2VVdmRXhiNzA1ZVVEbWhjOVZvdkZ4QzFYQzlUa0ZMSGdkQVBrMTB3dlUwNitvRWpzZTVTZkZ6aiJ9",
        },
        {"name":"HOW AR, AI, SENSORS & BLOCKCHAIN ARE CONVERGING INTO WEB 3.0",
        "teaser":"The world around us is gaining layer upon layer of digitized, virtually overlaid information — making it rich, meaningful, and interactive. As a result, our respective experiences of the same environment are becoming vastly different, personalized to our goals, dreams, and desires.",
        "source": "diamandis", 
        "link":"https://www.diamandis.com/blog/augmented-reality-whitepaper-part-3",
        },
        {"name":"Driving Competitive Advantage With Data and Artificial Intelligence",
        "teaser":"The AI-powered “haves” already are outpacing the “have-nots” in implementing AI solutions to automate processes, augment human capabilities, and deliver breakthrough products.",
        "source": "su.org", 
        "link":"https://su.org/blog/how-to-build-data-analytics-and-ai-capabilities/",
        },
        {"name":"AI Adoption in Healthcare: A Balancing Act",
        "teaser":"At Singularity University, we believe it is critical to understand emerging technologies and their future impact.",
        "source":"su.org", 
        "link":"https://su.org/blog/ai-adoption-in-healthcare/",
        },
        {"name":"The Rise of Wearable Technology in Health Care",
        "teaser":"While wearables’ fidelity may not yet match medical-grade monitors and devices, “good enough” coupled with around-the-clock capabilities, real-time data capture, storage, and analytics seem likely to provide real value.",
        "source": "jamanetwork", 
        "link":"https://jamanetwork.com/journals/jamanetworkopen/fullarticle/2723404#related-articles-tab",
        },
    ];

 
    items = this.blog_data.map(item => {
        return <BlogTeaser name={item.name} teaser={item.teaser} source={item.source} link={item.link} />;
   });

  render() {
    return (
        <div>
            <div className="container mit blog">
                <div className="container_message" >
                    <div className="content_text_title">Industry Blog + News</div>
                    <div className="content_text">
                    Learn about the latest trends and perspectives on diverse topics from world-wide industry including wellness and longevity research, medical innovation, and technology advancements that are reshaping the landscape of personalized wellness today.
                    </div> 
                    <Button className="button_learn_more" intent="primary" icon="chevron-right">Learn More</Button>
                </div>
            </div>
            <div className="blogs">
                <ul className="flex-grid-thirds">
                    {this.items}
                </ul>
            </div>
        </div>
    );
  }
}

export default Blog;